import type { Pp2ViewModel } from "../pp2ViewModel";

/** Google Maps Embed API "place" mode URL for the Location block map (spec 2.4, 5.5, Q34). */
export const mapEmbedUrl = (apiKey: string, placeId: string): string =>
  `https://www.google.com/maps/embed/v1/place?key=${encodeURIComponent(apiKey)}&q=place_id:${encodeURIComponent(placeId)}`;

/** Accessible name of the map iframe: `Map of {address || displayName}` (spec 5.5, 6). */
export const mapTitle = (address: string | null, displayName: string): string => `Map of ${address || displayName}`;

export type SocialNetwork = "instagram" | "facebook" | "linkedin";
export type SocialLink = { network: SocialNetwork; label: string; href: string };

const SOCIAL_ORDER: ReadonlyArray<{ network: SocialNetwork; label: string }> = [
  { network: "instagram", label: "Instagram" },
  { network: "facebook", label: "Facebook" },
  { network: "linkedin", label: "LinkedIn" },
];

/** The set social links in the design order Instagram, Facebook, LinkedIn (spec S4, 5.7). */
export function socialLinks(social: NonNullable<Pp2ViewModel["social"]>): SocialLink[] {
  return SOCIAL_ORDER.flatMap(({ network, label }) => {
    const href = social[network];
    return href ? [{ network, label, href }] : [];
  });
}
